import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function ScoreBar({ score }) {
    const color = score >= 80 ? "bg-emerald-500" : score >= 50 ? "bg-amber-500" : "bg-slate-400";
    return (_jsxs("div", { className: "flex items-center gap-2", children: [_jsx("div", { className: "h-2 w-24 overflow-hidden rounded-full bg-slate-200", children: _jsx("div", { className: `h-full ${color}`, style: { width: `${score}%` } }) }), _jsx("span", { className: "w-8 text-right text-sm tabular-nums", children: score })] }));
}
